import { cn, Popover, Toggle } from "@eisox/design-system";
import { OptionIcon } from "@eisox/icons";
import { useControllableState } from "@radix-ui/react-use-controllable-state";

import { m } from "~/paraglide/messages";

interface OptionsDropdownProps extends Popover.PopoverProps {
  displayUserDefinedPlanning?: boolean;
  onDisplayUserDefinedPlanningChange?: (display: boolean) => void;
}

const OptionsDropdown: React.FC<OptionsDropdownProps> = ({
  displayUserDefinedPlanning: displayUserDefinedPlanningProp,
  onDisplayUserDefinedPlanningChange,
  ...props
}) => {
  const [displayUserDefinedPlanning, setDisplayUserDefinedPlanning] = useControllableState({
    prop: displayUserDefinedPlanningProp,
    onChange: onDisplayUserDefinedPlanningChange,
    defaultProp: false,
  });

  return (
    <Popover.Root {...props}>
      <Popover.Trigger className="cursor-pointer" asChild>
        <OptionIcon />
      </Popover.Trigger>
      <Popover.Content className={cn("flex flex-col gap-[10px] text-base")} sideOffset={10} align="end">
        <p className="font-medium italic">{m.display()}</p>
        <Toggle pressed={displayUserDefinedPlanning} onPressedChange={setDisplayUserDefinedPlanning}>
          {m.user_planning()}
        </Toggle>
      </Popover.Content>
    </Popover.Root>
  );
};

export { OptionsDropdown };
export type { OptionsDropdownProps };
